<template>
  <div>
      <nav id="nav-menu" class="fixed-bottom py-0 d-flex justify-content-around mt-2">
    <div :style="mtdGetStyle('mantenimiento')" class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border" @click="mtdSendOption('mantenimiento')"><span :style="mtdGetStyleSpan('mantenimiento')" class="btn w-100"><strong>MANTENIMIENTO</strong></span></div>
    <div :style="mtdGetStyle('horario')" class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border" @click="mtdSendOption('horario')"><span :style="mtdGetStyleSpan('horario')" class="btn w-100"><strong>HORARIO</strong></span></div>
    
  </nav>
  </div>
</template>
<script>
export default {
  name: 'FooterEnfermeriaComponent',
  props: {
    pageView: String
  },
  data () {
    return {
      page: null
    }
  },
  created () {
   
  },
  methods: {
    mtdGetStyle:function(option){
      if (option == this.page && this.pageView != "home") return 'background: #2f395c';
      return '';
    },
    mtdGetStyleSpan:function(option){
      if (option == this.page && this.pageView != "home") return 'color:white';
      return '';
    },
    mtdSendOption: function(page){
      this.page=page;
      this.$emit('mtdChangePage',this.page)
    }
  },
}
</script>